<template>
  <div class="p-m-3 sp-page">
    <MockBanner />
    <h2>Sites &amp; Projects: how it would work</h2>
    <p class="sp-sub">A proposal for MBP. The pages in this menu section show every new or changed screen.</p>

    <div class="p-card p-p-4">
      <h4 style="margin-top: 0;">The idea</h4>
      <div class="sp-row" style="gap: 10px; font-size: 15px;">
        <span class="sp-chip live" style="font-size: 14px;">Site</span><i class="pi pi-arrow-right"></i>
        <span class="sp-chip live" style="font-size: 14px;">Project</span><i class="pi pi-arrow-right"></i>
        <span class="sp-chip live" style="font-size: 14px;">Enquiry</span><i class="pi pi-arrow-right"></i>
        <span class="sp-chip live" style="font-size: 14px;">Quote (one active, as today)</span>
      </div>
      <ul>
        <li><strong>Site:</strong> the place, with one address. Example: TRAFFORD WATERS, Trafford Boulevard, M41 7GG.</li>
        <li><strong>Project:</strong> one piece of work at the site: a block, phase or building. Example: PARCEL 3.</li>
        <li><strong>Enquiry:</strong> as today, one customer and one product type, now linked to a Project. Spare parts and small orders can use "No project".</li>
      </ul>
      <p>
        Today, one job tendered to several joiners is several enquiries, and the quote bank adds them all. On PARCEL 3, three joiners have live quotes at
        £450,731 each, so today's quote bank counts £1,352,193 for a job worth £450,731. With Projects, each job is counted <strong>once per product type</strong>: the average of the quotes while it is tendered (a setting),
        and the won value once won.
      </p>
    </div>

    <div class="p-card p-p-4 p-mt-3">
      <h4 style="margin-top: 0;">The three cases</h4>
      <table class="sp-table">
        <thead><tr><th>Case</th><th>Example (real TEST data)</th><th>What happens</th><th>Counts</th></tr></thead>
        <tbody>
          <tr>
            <td><strong>S1</strong> Different contractors, same job</td>
            <td><span class="sp-link" @click="go('/sitesProjects/projects/21')">GREY MARE LANE: MAIN SCHEME</span>. Doorsets quoted to RJC, JDM, L N Joinery and Faber at £196,929 each</td>
            <td>Separate enquiries under one Project. An information note at entry: "3 other contractors are quoting this project".</td>
            <td>Once: the average, {{ money(196929) }}, not {{ money(4 * 196929) }}</td>
          </tr>
          <tr>
            <td><strong>S2</strong> Same customer, same job, same product, two branches</td>
            <td><span class="sp-link" @click="go('/sitesProjects/projects/41')">PREMIER INN LITTLEHAMPTON</span>. Carter Lauren quoted by MIDLANDS £163,314 and DOORSETS £56,676</td>
            <td>A duplicate. Warning at entry with a link to the other quote; if the user carries on, management gets an email.</td>
            <td>Only one (setting: the latest)</td>
          </tr>
          <tr>
            <td><strong>S3</strong> Same job, different product types</td>
            <td><span class="sp-link" @click="go('/sitesProjects/projects/51')">WELDON LODGE: NEW HQ</span>. Kori Construction: Doorsets £12,567 and Ironmongery £614</td>
            <td>Separate enquiries under one Project. No warning. "Add another product type" copies the enquiry.</td>
            <td>Each one in full</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="p-card p-p-4 p-mt-3">
      <h4 style="margin-top: 0;">Dashboard: a second quote-bank tile</h4>
      <div class="sp-row">
        <div class="sp-kpi" style="max-width: 300px;">
          <div class="label">Quote bank (today's tile)</div><div class="value">{{ money(liveSum) }}</div>
          <div class="hint">Every live quote added up</div>
        </div>
        <div class="sp-kpi" style="max-width: 300px; border-color: #90caf9;">
          <div class="label">Quote bank: project basis (new)</div><div class="value">{{ money(counted) }}</div>
          <div class="hint">Each job once per product type · <span class="sp-link" @click="go('/sitesProjects/projectsReport')">open the Projects report</span></div>
        </div>
      </div>
      <p class="sp-muted" style="margin-bottom: 0;">Figures from the sample projects on these pages. On the full TEST data, the analysis of 09/09 found about 16% of the live
        pipeline counted more than once.</p>
    </div>

    <div class="p-card p-p-4 p-mt-3">
      <h4 style="margin-top: 0;">The screens</h4>
      <table class="sp-table">
        <tr v-for="p in pages" :key="p.to"><td style="width: 260px;"><span class="sp-link" @click="go(p.to)">{{ p.label }}</span></td><td>{{ p.text }}</td></tr>
      </table>
    </div>
  </div>
</template>

<script>
import MockBanner from './MockBanner.vue'
import { projects, projectTotals, money } from './mockData'
import { SITES_PROJECTS_PAGES } from './pages'

export default {
  name: 'SpOverview',
  components: { MockBanner },
  data() { return { pages: SITES_PROJECTS_PAGES.filter(p => p.to !== '/sitesProjects/overview') } },
  computed: {
    totals() { return projects.map(p => projectTotals(p.id)) },
    counted() { return this.totals.reduce((a, t) => a + t.counted, 0) },
    liveSum() { return this.totals.reduce((a, t) => a + t.liveSum, 0) }
  },
  methods: {
    money,
    go(to) { this.$router.push(to) }
  }
}
</script>

<style scoped>
@import './sitesProjects.css';
</style>
